'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { Checkbox } from '@hrworks/sui-core/Checkbox';
import { Grid } from '@hrworks/sui-core/Grid';
import { GridItem } from '@hrworks/sui-core/GridItem';

import { FormField } from '../FormField';
import type { NoticePeriodFieldsProps } from './NoticePeriodFields.types';

export const NoticePeriodFields = ({ visibility }: NoticePeriodFieldsProps) => {
  const [isChecked, setIsChecked] = useState(false);
  const t = useTranslations('FormFields');
  const tJob = useTranslations('Job');
  const tForm = useTranslations('Form');

  if (visibility === 'NotVisible' || visibility === 'Administrator') {
    return;
  }

  const selectNoneOption = { value: '', label: tForm('please-select') };

  const unitOptions = [
    selectNoneOption,
    { value: 'days', label: tJob('noticePeriodTimeUnit.days') },
    { value: 'weeks', label: tJob('noticePeriodTimeUnit.weeks') },
    { value: 'months', label: tJob('noticePeriodTimeUnit.months') },
  ];

  const referenceOptions = [
    selectNoneOption,
    { value: 'onEveryDay', label: tJob('noticePeriodTimeReference.onEveryDay') },
    { value: 'fifteenthOfMonth', label: tJob('noticePeriodTimeReference.fifteenthOfMonth') },
    { value: 'endOfMonth', label: tJob('noticePeriodTimeReference.endOfMonth') },
    { value: 'fifteenthOrEndOfMonth', label: tJob('noticePeriodTimeReference.fifteenthOrEndOfMonth') },
    { value: 'endOfQuarter', label: tJob('noticePeriodTimeReference.endOfQuarter') },
    { value: 'endOfYear', label: tJob('noticePeriodTimeReference.endOfYear') },
  ];

  return (
    <GridItem>
      <Grid>
        <GridItem>
          <Checkbox
            name="hasNoticePeriod"
            checked={isChecked}
            onValueChange={() => setIsChecked(!isChecked)}
            label={t('hasNoticePeriod')}
            data-guide-id={`form-field-hasNoticePeriod`}
          />
        </GridItem>
        {isChecked && (
          <>
            <FormField
              fieldKey="noticePeriodTimeAmount"
              size={{ xs: 12, md: 4 }}
              visibility={visibility}
              component="NumberInputField"
              min={0}
              signed={false}
            />
            <FormField
              fieldKey="noticePeriodTimeUnit"
              size={{ xs: 6, md: 4 }}
              component="Select"
              options={unitOptions}
              visibility={visibility}
            />
            <FormField
              fieldKey="noticePeriodTimeReference"
              size={{ xs: 6, md: 4 }}
              component="Select"
              options={referenceOptions}
              visibility={visibility}
            />
          </>
        )}
      </Grid>
    </GridItem>
  );
};
